"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddAttributeContainer = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const add_attribute_dialog_styles_1 = require("./add-attribute-dialog.styles");
const add_to_other_nodes_dialog_component_1 = require("./add-to-other-nodes-dialog.component");
const add_value_dialog_utils_1 = require("./add-value-dialog.utils");
const attribute_autocomplete_1 = require("./partials/attribute-autocomplete");
const validation_schema_1 = require("./validation-schema");
const attributes_1 = require("../../../client/attributes");
const hooks_1 = require("../../../client/hooks");
const global_tree_edit_warning_1 = require("../../../components/global-tree-edit-warning");
const context_1 = require("../../../context");
const generic_1 = require("../../../generic");
const utils_1 = require("../../../utils");
const hooks_2 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const localization_utils_1 = require("../../../../localization/localization.utils");
const store_1 = require("../../../../store");
const CREATE_ATTRIBUTE_FORM_ID = 'create-attribute-form';
const getErrorMessage = (error) => {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'Unknown error';
};
const AddAttributeContainer = ({ open, onClose, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isReEnrichmentInProgress } = (0, context_1.useCatalogActivityProgressContext)();
    const { addSuccess, addError } = (0, hooks_2.useNotification)();
    const { refetchQueriesOnStrategyAttributeChange } = (0, hooks_1.useRefetchQueries)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const productTreeRootNodeId = (0, store_1.useProductTreeRootNodeId)();
    const selectedStrategyNodeId = (0, store_1.useSelectedTreeNodeId)();
    const shouldShowGlobalTreeEditWarning = (0, store_1.useShouldShowGlobalTreeEditWarning)();
    const validationSchema = (0, validation_schema_1.useAttributeValidationSchema)();
    const { onGlobalTreeReplacement } = (0, global_tree_edit_warning_1.useGlobalTreeEditWarning)(selectedStrategyNodeId);
    const { addAttributesToSeveralNodes } = (0, attributes_1.useAddAttributesToNode)();
    const { editAttributes } = (0, attributes_1.useEditAttributes)();
    const [addToOtherNodesDialogConfig, setAddToOtherNodesDialogConfig] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { attributeOptionList, loading, isSearching, moreItemsLoading, hasNextPage, fetchMore, refetch, } = (0, attributes_1.useGetMissingAttributes)({
        productTreeRootNodeId,
        productTreeNodeId: selectedStrategyNodeId,
        options: { skip: !open },
    });
    const initialValues = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, generic_1.attributeInitialValues), { attributes: [] })), []);
    const dispatchError = (attributes, error) => {
        addError(t({
            key: 'ADD_ENTITY_ERROR',
            values: {
                count: String(attributes.length),
                entity: String(t({ key: 'ATTRIBUTE' })).toLowerCase(),
                b: localization_utils_1.renderBoldText,
            },
        }), error);
    };
    const handleAddItemsToHistory = (attributes, treeNodePaths) => {
        const historyItems = [];
        for (const treeNodePath of treeNodePaths) {
            for (const attribute of attributes) {
                const { values, name } = attribute;
                historyItems.push({
                    id: name,
                    entityType: store_1.ChangeEntityType.Attribute,
                    actionType: store_1.ChangeActionType.Add,
                    path: treeNodePath,
                });
                for (const valueItem of values) {
                    const historyItem = {
                        id: `${name}${store_1.LABEL_VALUE_PAIR_SEPARATOR}${valueItem.name}`,
                        entityType: store_1.ChangeEntityType.Value,
                        actionType: store_1.ChangeActionType.Add,
                        path: treeNodePath,
                    };
                    historyItems.push(historyItem);
                }
            }
        }
        dispatch((0, store_1.enrichAIAddChanges)(selectedCatalogId, historyItems));
    };
    const handleUpdateProductPresentation = (relatedTreeNodeIds) => refetchQueriesOnStrategyAttributeChange({
        selectedTreeNodeId: selectedStrategyNodeId,
        relatedTreeNodeIds,
    });
    const handleTreeReplacement = (isGlobalStrategyReplacementAccepted) => __awaiter(void 0, void 0, void 0, function* () {
        const isTreeReplacementNeeded = shouldShowGlobalTreeEditWarning && isGlobalStrategyReplacementAccepted;
        if (!isTreeReplacementNeeded) {
            return { rootNodeId: productTreeRootNodeId, targetNodeId: selectedStrategyNodeId };
        }
        const metadata = yield onGlobalTreeReplacement();
        if (!metadata.targetNodeId) {
            throw new Error('Target node is not found');
        }
        return metadata;
    });
    const handleAddAttributesToSelectedNode = (_a) => __awaiter(void 0, [_a], void 0, function* ({ attributes, isGlobalStrategyReplacementAccepted }) {
        try {
            const { rootNodeId, targetNodeId } = yield handleTreeReplacement(isGlobalStrategyReplacementAccepted);
            const parsedAttributesData = attributes.map(add_value_dialog_utils_1.parseFormValues);
            const promises = [];
            parsedAttributesData.forEach((_a) => {
                var { isDescriptionChanged, newValues = [], valuesWithNewGuideline = [] } = _a, attribute = __rest(_a, ["isDescriptionChanged", "newValues", "valuesWithNewGuideline"]);
                if ((valuesWithNewGuideline === null || valuesWithNewGuideline === void 0 ? void 0 : valuesWithNewGuideline.length) || isDescriptionChanged) {
                    promises.push(editAttributes([Object.assign(Object.assign({}, attribute), { values: valuesWithNewGuideline })], [rootNodeId]));
                }
            });
            const updatedTreeNodePaths = yield addAttributesToSeveralNodes(attributes, [targetNodeId]);
            const responses = yield Promise.allSettled(promises);
            for (const response of responses) {
                if (response.status === 'rejected') {
                    throw new Error(getErrorMessage(response.reason));
                }
            }
            handleAddItemsToHistory(attributes, updatedTreeNodePaths);
            setAddToOtherNodesDialogConfig(attributes);
        }
        catch (error) {
            dispatchError(attributes, getErrorMessage(error));
        }
        finally {
            onClose();
        }
    });
    const handleAddAttributesToOtherNodes = (selectedNodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const updatedTreeNodePaths = yield addAttributesToSeveralNodes(addToOtherNodesDialogConfig, selectedNodeIds);
            handleAddItemsToHistory(addToOtherNodesDialogConfig, updatedTreeNodePaths);
            const entities = addToOtherNodesDialogConfig.map(({ name }) => name).join(', ');
            addSuccess(t({
                key: 'ADD_ENTITY_TO_OTHER_NODES_SUCCESS',
                values: {
                    count: addToOtherNodesDialogConfig.length,
                    entity: String(t({ key: 'ATTRIBUTE' })).toLowerCase(),
                    entityName: entities,
                },
            }));
            void handleUpdateProductPresentation(selectedNodeIds);
        }
        catch (error) {
            dispatchError(addToOtherNodesDialogConfig, getErrorMessage(error));
            void handleUpdateProductPresentation();
        }
        finally {
            setIsLoading(false);
            setAddToOtherNodesDialogConfig(null);
        }
    });
    const handleAddToOtherNodesDialogClose = () => {
        setAddToOtherNodesDialogConfig(null);
        void handleUpdateProductPresentation();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, open && (react_1.default.createElement(generic_1.CreateEntityDialog, { allowCreation: true, isReadOnly: isReEnrichmentInProgress, initialValues: initialValues, title: ({ values, setFieldValue }) => {
            var _a, _b;
            const attributeValues = (_a = values[generic_1.AttributeFormFieldNames.Attributes]) !== null && _a !== void 0 ? _a : [];
            const existingAttributeNames = attributeValues.map(({ name }) => name);
            const availableAttributes = attributeOptionList.filter(({ value }) => (!!value && !existingAttributeNames.some((existingName) => (0, utils_1.areEqualCaseInsensitive)(existingName, value))));
            const handleSelectAttribute = (selectedAttributeName) => {
                var _a;
                const selectedAttribute = availableAttributes.find(({ value }) => value === selectedAttributeName);
                const nextAttribute = {
                    name: selectedAttributeName,
                    description: (_a = selectedAttribute === null || selectedAttribute === void 0 ? void 0 : selectedAttribute.description) !== null && _a !== void 0 ? _a : '',
                    values: [],
                };
                void setFieldValue(generic_1.AttributeFormFieldNames.Attributes, [nextAttribute, ...attributeValues], true);
            };
            const canShowHeaderAddButton = !((_b = attributeValues === null || attributeValues === void 0 ? void 0 : attributeValues[0]) === null || _b === void 0 ? void 0 : _b.readonly) && !isReEnrichmentInProgress;
            return (react_1.default.createElement(add_attribute_dialog_styles_1.StyledCreateEntityDialogTitle, { className: "create-entity-dialog-title" }, react_1.default.createElement("div", { className: "create-entity-dialog-title-text" }, t({
                key: 'ADD_ENTITY_TO_ENTITY',
                values: {
                    entity: String(t({ key: 'ATTRIBUTE' })).toLowerCase(),
                    targetEntity: String(t({ key: 'NODE' })).toLowerCase(),
                },
            })), canShowHeaderAddButton && (react_1.default.createElement(attribute_autocomplete_1.AttributeAutocomplete, { className: "create-entity-dialog-title-action", options: availableAttributes, selected: "", allowCreation: true, keepOpenOnSelect: true, preserveInputOnSelect: true, isLoading: loading || isSearching, moreItemsLoading: moreItemsLoading, hasNextPage: hasNextPage, onLoadMore: fetchMore, onSearch: refetch, onSelect: handleSelectAttribute }))));
        }, formId: CREATE_ATTRIBUTE_FORM_ID, validationSchema: validationSchema, valueOptionListStrategyNodeId: productTreeRootNodeId, selectedStrategyNodeId: selectedStrategyNodeId, attributesOptionList: attributeOptionList, isValueListHeightDynamic: true, valueSectionLabels: {
            added: t({ key: 'VALUE_LIST_SECTION_ADDED' }),
            existing: t({ key: 'VALUE_LIST_SECTION_EXISTING' }),
        }, isLoading: loading, onSubmit: handleAddAttributesToSelectedNode, onClose: onClose })), !!addToOtherNodesDialogConfig && (react_1.default.createElement(add_to_other_nodes_dialog_component_1.AddToOtherNodesDialog, { onClose: handleAddToOtherNodesDialogClose, onSubmit: handleAddAttributesToOtherNodes, attributes: addToOtherNodesDialogConfig, isLoading: isLoading }))));
};
exports.AddAttributeContainer = AddAttributeContainer;
exports.default = exports.AddAttributeContainer;
